import IdentifyApi from '@apis/auth/IdentifyApi';
import { IdentifyRequest } from '@models/identify';
import { handleIdentificationSuccess } from '@utils/utils';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

// 본인인증 페이지 호출
function useIdentification() {
    const { t } = useTranslation('signUp');

    return (request: IdentifyRequest) => {
        IdentifyApi.identify(request)
            .then(handleIdentificationSuccess)
            .catch((e) => {
                console.error('본인인증 오류', e);
                toast.error(t('toast.identifyFailed'));
            });
    };
}

export default useIdentification;
